(function ($) {
    "use strict";

    $(document).ready(function () {
        $(".js-toggle").on("click", function () {
            var $parent = $(this).closest(".recent-research__item");
            var $content = $parent.find(".js-content");

            // Toggle is-open class on parent
            if ($parent.hasClass("is-open")) {
                $parent.removeClass("is-open");
                $content.css("max-height", "0");
            } else {
                // Close other open items
                $(".recent-research__item.is-open").removeClass("is-open")
                    .find(".js-content").css("max-height", "0");

                // Open the clicked item
                $parent.addClass("is-open");
                $content.css("max-height", $content[0].scrollHeight + "px");
            }
        });
    });

})(jQuery);
